import type { ConsentPurpose } from './contract'

// The anonymous bucketing cookie is shared by analytics and experimentation.
// Stitched/member identities also support personalised LERE recommendations.
export const TRACKING_IDENTITY_PURPOSES = {
  domain: ['analytics', 'experimentation'],
  stitched: ['analytics', 'experimentation', 'personalisation'],
} as const satisfies Record<string, ReadonlyArray<ConsentPurpose>>

export type TrackingIdentity = keyof typeof TRACKING_IDENTITY_PURPOSES

export function canRetainTrackingIdentity(purposes: ReadonlyArray<ConsentPurpose>, identity: TrackingIdentity): boolean {
  return TRACKING_IDENTITY_PURPOSES[identity].some(purpose => purposes.includes(purpose))
}
